import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from '@ori/i18n';
export var Localization = function(props) {
    var id = props.id, defaultMessage = props.defaultMessage, values = props.values;
    return /*#__PURE__*/ _jsx("span", {
        "data-key": id,
        className: "translate",
        children: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: id,
            defaultMessage: defaultMessage,
            values: values
        }, id)
    });
};
